// extracted by css-extract-rspack-plugin
module.exports =  {"modal":"HyperlinkMaker-EFI8__modal","inputfield-url":"HyperlinkMaker-vHcu__inputfield-url"};